import React, { useEffect } from 'react';
import { MapContainer } from '@components/organism/MapContainer';
import { Map } from '@components/atoms/Map';
import { SelectAccountType } from '@components/molecules/SelectAccountType';
import { RoundIcon, RoundIconVariants } from '@components/atoms/RoundIcon';
import styles from './RoleSelector.module.css';
import { useNavigate } from 'react-router-dom';
import { useGetRoles } from '@services/useUserTypes';
import { useData } from '@hooks/useData';
import { Loader } from '@components/atoms/Loader';

export function RoleSelector() {
    const { roles } = useData();
    const navigate = useNavigate();
    const { request: requestRoles, loading } = useGetRoles();

    useEffect(() => {
        requestRoles();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Fetch on mount

    return (
        <MapContainer>
            {!roles || loading ? (
                <div className={styles.loader}>
                    <Loader />
                </div>
            ) : (
                <div className="position-relative w-100 h-100">
                    <Map locations={[]} style={JSON.stringify({ height: '100%', width: '100%' })} />

                    <div
                        className="position-absolute top-0 start-0 w-100 h-100"
                        style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.4)',
                            zIndex: 2,
                        }}></div>

                    <div className="position-absolute top-0 z-3 p-4">
                        <RoundIcon
                            classes={styles.roundIcon}
                            icon="fa-thin fa-bars"
                            variant={RoundIconVariants.variant1}
                            onClick={() => navigate('/login')}
                        />
                    </div>

                    <div className="position-absolute bottom-0 w-100 z-3">
                        <SelectAccountType
                            onNext={function (): void {
                                throw new Error('Function not implemented.');
                            }}
                        />
                    </div>
                </div>
            )}
        </MapContainer>
    );
}
